import { lazy } from 'react';
import useLanguageRedirect from '../../Core/Hooks/HookUrlRedirect/useLanguageRedirect';

const BrochureViewerPage = lazy(() =>
  import('../../Components/Pages/BrochureViewerPage/BrochureViewerPage')
);

export const RoutesBrochure = [
  {
    path: '/brochure-viewer',
    exact: true,
    component: useLanguageRedirect
  },
  {
    path: '/:language/brochure-viewer',
    exact: true,
    component: BrochureViewerPage
  }
];
